import {
  createTheme,
  createUnifiedThemeFromV4,
  createBaseThemeOptions,
  palettes,
  UnifiedTheme,
} from '@backstage/theme';
import pageThemes from './pageThemes';

// eslint-disable-next-line
const baseTheme = createTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.dark,
      primary: {
        main: '#ffffff',
        light: '#4C9AFF',
        dark: '#172B4D',
      },
      secondary: {
        main: '#FF5630',
        light: '#FFAB00',
        dark: '#6554C0',
      },
      grey: {
        50: '#C1C7D0',
        100: '#7A869A',
        200: '#6B778C',
        300: '#5E6C84',
        400: '#505F79',
        500: '#42526E',
        600: '#344563',
        700: '#253858',
        800: '#172B4D',
        900: '#091E42',
      },
      error: {
        main: '#FF5630',
        light: '#FF8F73',
        dark: '#DE350B',
      },
      warning: {
        main: '#FFAB00',
        light: '#FFE380',
        dark: '#FF8B00',
      },
      success: {
        main: '#36B37E',
        light: '#79F2C0',
        dark: '#006644',
      },
      info: {
        main: '#0065FF',
        light: '#4C9AFF',
        dark: '#0747A6',
      },
      navigation: {
        background: '#2b2b2b',
        indicator: '#8f5e15',
        color: '#ffffff',
        selectedColor: '#0000ff',
      },
      text: {
        primary: '#ffffff',
      },
      background: {
        default: '#2b2b2b',
      },
    },
  }),
  fontFamily: 'Roboto, sans-serif',
  defaultPageTheme: 'home',
  pageTheme: pageThemes,
});

export const apertureTheme: UnifiedTheme = createUnifiedThemeFromV4({
  ...baseTheme,
  overrides: {
    ...baseTheme.overrides,
  },
});
